export const BackArrowIcon = () => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M-1.74846e-07 4.5L3.77531 0.5L4.46816 1.23407L1.87536 3.981L10 3.981L10 5.019L1.87536 5.01899L4.46816 7.76593L3.77531 8.5L-1.74846e-07 4.5Z" />
    </svg>
  );
};
